import {CommonColumnComponent} from '../parts/common-column/common-column.component';
import {CommonDateComponent} from '../parts/common-date/common-date.component';
import {CommonStatusComponent} from '../parts/common-status/common-status.component';
import {CommonSchedulerComponent} from '../parts/common-scheduler/common-scheduler.component';
import {CustomSpecialConditionComponent} from '../parts/custom-special-condition/custom-special-condition.component';
import {CommonTimerComponent} from '../parts/common-timer/common-timer.component';
import {CommonSendEmailComponent} from '../parts/common-send-email/common-send-email.component';
import {CommonTimerEmailComponent} from '../parts/common-timer-email/common-timer-email.component';
import {CommonStatusArchiveComponent} from '../parts/common-status-archive/common-status-archive.component';
import {CommonTaskStatusArchiveComponent} from '../parts/common-task-status-archive/common-task-status-archive.component';
import {CommonStatusTimerEmailComponent} from '../parts/common-status-timer-email/common-status-timer-email.component';
import {CommonTimerNotificationComponent} from '../parts/common-timer-notification/common-timer-notification.component';
import {PulseCreatedSendNotificationComponent} from '../parts/pulse-created-send-notification/pulse-created-send-notification.component';
import {CommonTextChangeComponent} from '../parts/common-text-change/common-text-change.component';
import {CommonProductChangeUpdateComponent} from '../parts/common-product-change-update/common-product-change-update.component';
import {CommonStatusNotifyComponent} from '../parts/common-status-notify/common-status-notify.component';
import {CommonStatusChangeUserComponent} from '../parts/common-status-change-user/common-status-change-user.component';
import {StatusGroupMovingComponent} from '../parts/status-group-moving/status-group-moving.component';
import {StatusConditionCreateComponent} from '../parts/status-condition-create/status-condition-create.component';
import {StatusGroupMovingNotifyComponent} from '../parts/status-group-moving-notify/status-group-moving-notify.component';
import {StatusTimerArchiveComponent} from '../parts/status-timer-archive/status-timer-archive.component';
import {WorkRelationComponent} from '../parts/work-relation/work-relation.component';
import {CommonWorkflowCreateTaskComponent} from '../parts/common-workflow-create-task/common-workflow-create-task.component';
import {CommonWorkflowDeleteTaskComponent} from '../parts/common-workflow-delete-task/common-workflow-delete-task.component';
import {CommonWorkflowUpdateTaskComponent} from '../parts/common-workflow-update-task/common-workflow-update-task.component';
import {CommonAuditCreateTaskComponent} from '../parts/common-audit-create-task/common-audit-create-task.component';
import {CommonAuditDeleteTaskComponent} from '../parts/common-audit-delete-task/common-audit-delete-task.component';
import {CommonAuditUpdateTaskComponent} from '../parts/common-audit-update-task/common-audit-update-task.component';
import {CommonSupervisoryUpdateTaskComponent} from '../parts/common-supervisory-update-task/common-supervisory-update-task.component';
import {CommonLogTaskArchiveComponent} from '../parts/common-log-task-archive/common-log-task-archive.component';
import {IntegrateSupervisoryCreatComponent} from '../parts/integrate-supervisory-creat/integrate-supervisory-creat.component';
import {IntegrateSupervisoryTaskRuleCreatComponent} from '../parts/integrate-supervisory-task-rule-creat/integrate-supervisory-task-rule-creat.component';
import {CreateTaskByIndicatorAbnormalStatusComponent} from '../parts/create-task-by-indicator-abnormal-status/create-task-by-indicator-abnormal-status.component';
import {ScanAuditOrIndicatorWhenIndicatorStatusComponent} from '../parts/scan-audit-or-indicator-when-indicator-status/scan-audit-or-indicator-when-indicator-status.component';
import {GtjaGMOperationPlantCreateTaskComponent} from '../parts/gtja-gmoperation-plant-create-task/gtja-gmoperation-plant-create-task.component';
import {TimingStatusGroupMovingComponent} from '../parts/timing-status-group-moving/timing-status-group-moving.component';

const PartConfig = {
  'automationCommonColumn': CommonColumnComponent,
  'automationCommonDate': CommonDateComponent,
  'automationCommonScheduler': CommonSchedulerComponent,
  'automationCommonStatus': CommonStatusComponent,
  'automationCommonStatusArchive': CommonStatusArchiveComponent,
  'automationCommonTaskStatusArchive': CommonTaskStatusArchiveComponent,
  'automationCommonTextArchive': CommonTextChangeComponent,
  'automationCustomSpecialCondition': CustomSpecialConditionComponent,
  'automationCommonTimer': CommonTimerComponent,
  'automationCommonSendEmail': CommonSendEmailComponent,
  'automationCommonTimerEmail': CommonTimerEmailComponent,
  'automationCommonStatusTimerEmail': CommonStatusTimerEmailComponent,
  'automationPulseCreatedSendNotification': PulseCreatedSendNotificationComponent,
  'automationProductUpdate': CommonProductChangeUpdateComponent,
  'commonStatusNotify': CommonStatusNotifyComponent,
  'statusConditionCreate': StatusConditionCreateComponent,
  'commonStatusChangeUser': CommonStatusChangeUserComponent,
  'statusGroupMoving': StatusGroupMovingComponent,
  'timingStatusGroupMoving': TimingStatusGroupMovingComponent,
  'statusGroupMovingNotify': StatusGroupMovingNotifyComponent,
  'statusTimerArchive': StatusTimerArchiveComponent,
  'workRelation': WorkRelationComponent,
  'commonWorkflowCreateTask': CommonWorkflowCreateTaskComponent,
  'workflowDeleteTask': CommonWorkflowDeleteTaskComponent,
  'workflowUpdateTask': CommonWorkflowUpdateTaskComponent,
  'auditCreateTask': CommonAuditCreateTaskComponent,
  'auditDeleteTask': CommonAuditDeleteTaskComponent,
  'auditUpdateTask': CommonAuditUpdateTaskComponent,
  'recurringNotice': CommonTimerNotificationComponent,
  'supervisoryUpdateTask': CommonSupervisoryUpdateTaskComponent,
  'logTaskArchive': CommonLogTaskArchiveComponent,
  'createTaskByIndicatorStatus': IntegrateSupervisoryCreatComponent,
  'createTaskWhenIndicatorByTaskDef': IntegrateSupervisoryTaskRuleCreatComponent,
  'createTaskByIndicatorAbnormalStatus': CreateTaskByIndicatorAbnormalStatusComponent,
  'scanAuditOrIndicatorWhenIndicatorStatus': ScanAuditOrIndicatorWhenIndicatorStatusComponent,
  'gtjaGMOperationPlantCreateTask': GtjaGMOperationPlantCreateTaskComponent
};
export {
  PartConfig,
  CommonColumnComponent,
  CommonDateComponent,
  CommonStatusComponent,
  CommonSchedulerComponent,
  CustomSpecialConditionComponent,
  CommonTimerComponent,
  CommonSendEmailComponent,
  CommonTimerEmailComponent,
  CommonStatusTimerEmailComponent,
  PulseCreatedSendNotificationComponent,
  CommonTimerNotificationComponent,
  IntegrateSupervisoryCreatComponent,
  IntegrateSupervisoryTaskRuleCreatComponent,
  CreateTaskByIndicatorAbnormalStatusComponent,
  ScanAuditOrIndicatorWhenIndicatorStatusComponent,
  GtjaGMOperationPlantCreateTaskComponent
};
